import script from "./BaseSubscriptionComponent.vue?vue&type=script&lang=js"
export * from "./BaseSubscriptionComponent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__